import React from "react"
import { Icon } from "../../../components"

export default function ({
  title,
  label,
  showCalendarIcon,
  counter,
  onClickMsg,
  buttonLabel = "View calendar",
  dataCy,
}: {
  title: string
  label: string
  counter: number
  showCalendarIcon: boolean
  onClickMsg?: () => void
  buttonLabel?: string
  dataCy: string
}) {
  return (
    <div className="card flex flex-col justify-between items-center">
      <h3 className="heading text-center" data-cy={`${dataCy}-title`}>
        {title}
      </h3>
      <div
        className="absolute w-full p-6 self-center-x self-center-y"
        data-cy={`${dataCy}-img`}
      >
        {!showCalendarIcon && <Icon.Calendar />}
      </div>

      <div className="relative w-fit bg-concrete text-center rounded-xl px-[10px] py-3 space-y-2 min-w-[120px]">
        <h5
          className="heading text-[80px] leading-[0.8]"
          data-cy={`${dataCy}-counter`}
        >
          {counter}
        </h5>
        <p data-cy={`${dataCy}-unit`}>{label}</p>
      </div>
      <div>
        {onClickMsg && (
          <button
            onClick={onClickMsg}
            className="button primary text-center"
            data-cy={`${dataCy}-cta`}
          >
            {buttonLabel}
          </button>
        )}
      </div>
    </div>
  )
}
